import { render, staticRenderFns } from "./OnlineStatus.vue?vue&type=template&id=66158df4&"
import script from "./OnlineStatus.vue?vue&type=script&lang=js&"
export * from "./OnlineStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports